export const ADD_FIELD_HEADER_BUTTON_ID = 'add-field-column-header'
export const STICKY_ADD_FIELD_BUTTON_ID = 'datagrid.add-field.button'
export const EDIT_FIELD_HEADER_COLUMN_ID = 'edit-field-column-header'

export const DOUBLE_CLICK_INTERVAL = 500

export const SHOW_PASTING_BANNER_DURATION_MS = 3000
